import React, { useState } from 'react'
import addHours from 'date-fns/addHours'
import endOfTomorrow from 'date-fns/endOfTomorrow'
import startOfToday from 'date-fns/startOfToday'

import { DatePicker } from '../../common/date'
import { ErrorZone } from '../../components/error_zone'
import { Form, Button, Input, stringToSlug } from '@guillotinaweb/react-gmi'
import { defaultHomeSections } from '../../consts'
import { formatStartEnd } from '../../utils'

const today = addHours(startOfToday(), 2)
const tomorrow = addHours(endOfTomorrow(), 2)

export function HomeForm({ onSubmit }) {
  const [name, setName] = useState('')
  const [error, setError] = useState('')
  const [start, setStart] = useState(today.toISOString())
  const [end, setEnd] = useState(tomorrow.toISOString())
  const [loading, setLoading] = useState(false)

  async function submit() {
    const [date_start, date_end] = formatStartEnd(start, end)
    const optional = name
      ? {
          id: stringToSlug(name),
          home_name: name,
        }
      : {}

    if (new Date(date_start) >= new Date(date_end)) {
      setError('The end date must be greater than the start date.')
      return
    }

    setError('')
    setLoading(true)
    await onSubmit({
      ...optional,
      '@type': 'Home',
      date_start,
      date_end,
      sections: defaultHomeSections,
    })
    setLoading(false)
  }

  return (
    <Form onSubmit={submit}>
      <h1 className="title is-size-4 has-text-primary">Add Home content</h1>
      {error && <ErrorZone className="is-size-7">{error}</ErrorZone>}
      <label className="label">Name (optional):</label>
      <Input placeholder="Name" value={name} onChange={setName} />
      <DatePicker
        value={start}
        name="From"
        onUpdate={(e) => setStart(e.target.value)}
      />
      <DatePicker
        value={end}
        name="To"
        onUpdate={(e) => setEnd(e.target.value)}
      />

      <div style={{ marginTop: 20 }} className="level level-right">
        <Button className="is-primary" loading={loading}>
          Add
        </Button>
      </div>
    </Form>
  )
}
